import { mapGetters } from "vuex";
import { stringHelper } from "@/components/mixins/stringHelper";
import { formatDateTime } from '@/components/mixins';

export default {
  name: "MlePrintHeader",
  mixins: [stringHelper,formatDateTime],
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(["getContentItem", "tenantDetails"])
  },
  created(){
      
  },
  methods:{

  },
};